import React from 'react';
import {
  CheckOutlined,
  ClockCircleOutlined,
  ReloadOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Button, Popover, Tag, Tooltip, Typography } from 'antd';

const pendingButtonStyle: React.CSSProperties = {
  background: '#fffbe6',
  borderColor: '#ffe58f',
  color: '#ad6800',
};

interface DataChangeRequestStatusProps {
  error?: string;
  pending: boolean;
  pendingContent?: React.ReactNode;
  pendingTitle?: React.ReactNode;
  retry: () => void;
  saving: boolean;
}

export const DataChangeRequestValue: React.FC<{
  previous?: boolean;
  value?: React.ReactNode;
}> = ({ previous = false, value }) => {
  const empty = value === undefined || value === null || value === '';
  if (empty) {
    const emptyValue = (
      <Typography.Text style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
        empty
      </Typography.Text>
    );
    return previous ? <del>{emptyValue}</del> : emptyValue;
  }

  return <Typography.Text delete={previous}>{value}</Typography.Text>;
};

const DataChangeRequestStatus: React.FC<DataChangeRequestStatusProps> = ({
  error,
  pending,
  pendingContent,
  pendingTitle = 'Changes awaiting Mabel review',
  retry,
  saving,
}) => {
  if (saving)
    return (
      <Tag color="processing" icon={<SyncOutlined spin />}>
        Saving
      </Tag>
    );

  if (error)
    return (
      <Tooltip title={error}>
        <Button danger icon={<ReloadOutlined />} onClick={retry} size="small">
          Retry
        </Button>
      </Tooltip>
    );

  if (pending) {
    const button = (
      <Button
        icon={<ClockCircleOutlined />}
        size="small"
        style={pendingButtonStyle}
      >
        Pending
      </Button>
    );

    return pendingContent ? (
      <Popover
        content={pendingContent}
        placement="left"
        title={pendingTitle}
        trigger="click"
      >
        {button}
      </Popover>
    ) : (
      button
    );
  }

  return (
    <Typography.Text type="secondary">
      <CheckOutlined /> Synced
    </Typography.Text>
  );
};

export default DataChangeRequestStatus;
